/**
 * RETOBLOCK TOOLBOX CATEGORY ICONS
 * Tự động tạo và hiển thị icon đại diện chuyên biệt cho từng nhóm lệnh Scratch Blockly,
 * thay thế thanh màu cạnh trái theo chuẩn nhận diện thương hiệu RETOCODE.
 */

export function getCategoryIconSvg(categoryName) {
  const name = (categoryName || '').toUpperCase().trim();

  // 1. SỰ KIỆN (Events) - Tia chớp / Trigger
  if (name.includes('SỰ KIỆN')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="#FFB800" stroke="none">
      <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/>
    </svg>`;
  }

  // 2. ĐIỀU KHIỂN (Control) - Vòng lặp / Flow control
  if (name.includes('ĐIỀU KHIỂN')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF9900" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 2l4 4-4 4"/>
      <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
      <path d="M7 22l-4-4 4-4"/>
      <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
    </svg>`;
  }

  // 3. CHUYỂN ĐỘNG (Motion) - Bánh xe / Xe robot
  if (name.includes('CHUYỂN ĐỘNG')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/>
      <circle cx="7" cy="17" r="2"/>
      <path d="M9 17h6"/>
      <circle cx="17" cy="17" r="2"/>
    </svg>`;
  }

  // 4. CẢM BIẾN (Sensors) - Radar / Sóng cảm biến
  if (name.includes('CẢM BIẾN')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"/>
      <path d="M5 12a7 7 0 0 1 7-7"/>
      <path d="M8 12a4 4 0 0 1 4-4"/>
      <circle cx="12" cy="12" r="2.5" fill="#0EA5E9"/>
      <path d="M12 14.5v7.5"/>
      <path d="M8 22h8"/>
    </svg>`;
  }

  // 5. ĐÈN & CÒI (Light & Sound) - Đèn sáng & Âm thanh
  if (name.includes('ĐÈN') || name.includes('CÒI')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C026D3" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 18h6"/>
      <path d="M10 22h4"/>
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/>
    </svg>`;
  }

  // 6. PHÉP TOÁN (Operators) - Toán tử & Logic
  if (name.includes('PHÉP TOÁN')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22C55E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="4" y1="9" x2="10" y2="9"/>
      <line x1="7" y1="6" x2="7" y2="12"/>
      <line x1="14" y1="9" x2="20" y2="9"/>
      <line x1="4" y1="17" x2="10" y2="17"/>
      <circle cx="17" cy="14" r="1.2" fill="#22C55E"/>
      <circle cx="17" cy="20" r="1.2" fill="#22C55E"/>
      <line x1="14" y1="17" x2="20" y2="17"/>
    </svg>`;
  }

  // 7. BIẾN SỐ (Variables) - Nhãn biến (x)
  if (name.includes('BIẾN SỐ')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F97316" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="4"/>
      <path d="m8 9 8 6"/>
      <path d="m16 9-8 6"/>
    </svg>`;
  }

  // 8. DANH SÁCH (Lists) - Hàng danh sách
  if (name.includes('DANH SÁCH')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#EA580C" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="8" y1="6" x2="21" y2="6"/>
      <line x1="8" y1="12" x2="21" y2="12"/>
      <line x1="8" y1="18" x2="21" y2="18"/>
      <circle cx="4" cy="6" r="1.5" fill="#EA580C"/>
      <circle cx="4" cy="12" r="1.5" fill="#EA580C"/>
      <circle cx="4" cy="18" r="1.5" fill="#EA580C"/>
    </svg>`;
  }

  // 9. KHỐI CỦA TÔI (My Blocks) - Khối ghép Puzzle
  if (name.includes('KHỐI') || name.includes('TÔI')) {
    return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F43F5E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M19.439 7.85c-.049-.322.059-.648.289-.878l1.568-1.568a1.5 1.5 0 0 0-2.121-2.121l-1.568 1.568a1 1 0 0 1-.878.29c-.322-.049-.648-.222-.85-.47L14.75 3.1a2 2 0 0 0-3.5 0l-1.129 1.571c-.202.248-.528.421-.85.47a1 1 0 0 1-.878-.29L6.825 3.283a1.5 1.5 0 0 0-2.121 2.121l1.568 1.568c.23.23.338.556.29.878-.049.322-.222.648-.47.85L4.52 9.829a2 2 0 0 0 0 3.5l1.571 1.129c.248.202.421.528.47.85a1 1 0 0 1-.29.878l-1.568 1.568a1.5 1.5 0 0 0 2.121 2.121l1.568-1.568c.23-.23.556-.338.878-.29.322.049.648.222.85.47l1.129 1.571a2 2 0 0 0 3.5 0l1.129-1.571c.202-.248.528-.421.85-.47a1 1 0 0 1 .878.29l1.568 1.568a1.5 1.5 0 0 0 2.121-2.121l-1.568-1.568c-.23-.23-.338-.556-.29-.878.049-.322.222-.648.47-.85l1.571-1.129a2 2 0 0 0 0-3.5l-1.571-1.129c-.248-.202-.421-.528-.47-.85z"/>
    </svg>`;
  }

  // Fallback mặc định
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#23A9E1" stroke-width="2.2"><circle cx="12" cy="12" r="9"/></svg>`;
}

/**
 * Đăng ký mở rộng Blockly.ToolboxCategory để tự động chèn icon và xóa viền màu cạnh trái
 */
export function registerToolboxCategoryIcons(Blockly) {
  if (!Blockly || !Blockly.ToolboxCategory || !Blockly.ToolboxCategory.prototype) return;
  if (Blockly.ToolboxCategory.prototype._retoCategoryInjected) return;
  Blockly.ToolboxCategory.prototype._retoCategoryInjected = true;

  // 1. Loại bỏ hoàn toàn thanh viền màu ở cạnh trái
  Blockly.ToolboxCategory.prototype.addColourBorder_ = function (colour) {
    this.colour_ = colour;
    if (this.rowDiv_) {
      this.rowDiv_.style.borderLeft = 'none';
    }
  };

  // 2. Chèn icon SVG trước nhãn tên của nhóm lệnh
  const origCreateIconDom = Blockly.ToolboxCategory.prototype.createIconDom_;
  Blockly.ToolboxCategory.prototype.createIconDom_ = function () {
    const iconSpan = origCreateIconDom ? origCreateIconDom.call(this) : document.createElement('span');
    iconSpan.className = 'blocklyTreeIcon reto-cat-icon';
    iconSpan.style.display = 'inline-flex';
    const catName = (this.name_ || '').trim();
    iconSpan.innerHTML = getCategoryIconSvg(catName);
    return iconSpan;
  };
}

/**
 * Quét và đảm bảo mọi hàng danh mục trong DOM đều hiển thị icon thay vì thanh viền màu
 */
export function applyCategoryIconsToDom(container = document) {
  const rows = container.querySelectorAll('.blocklyToolboxCategory, .blocklyTreeRow');
  rows.forEach((row) => {
    // Xóa thanh màu
    row.style.borderLeft = 'none';

    const label = row.querySelector('.blocklyTreeLabel, .blocklyToolboxCategoryLabel');
    if (!label) return;

    const catName = label.textContent.trim();
    let existingIcon = row.querySelector('.reto-cat-icon');

    if (!existingIcon) {
      existingIcon = document.createElement('span');
      existingIcon.className = 'blocklyTreeIcon reto-cat-icon';
      existingIcon.innerHTML = getCategoryIconSvg(catName);
      const parent = label.parentElement || row;
      parent.insertBefore(existingIcon, label);
    } else if (!existingIcon.innerHTML.trim()) {
      existingIcon.innerHTML = getCategoryIconSvg(catName);
    }
  });
}
